// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  pairId: __t.u64().primaryKey().name("pair_id"),
  aId: __t.u64().name("a_id"),
  bId: __t.u64().name("b_id"),
  worldId: __t.u64().name("world_id"),
  familiarity: __t.u32(),
  lastMetAt: __t.timestamp().name("last_met_at"),
});
